export default __webpack_public_path__ + "static/media/detail_mobile_4_4.314503a2.png";